const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class Ping {
    constructor(obj) {
        this._id = obj._id;
        this.deviceId = obj.deviceId;
        this.lastPing = obj.lastPing;
    }

    get lastPingDate() {
        return new Date(this.lastPing)
    }
}